<template>
  <a-row :gutter="16">
    <a-col :xxl="4" :xl="6" :lg="8" :md="12">
      <a-range-picker v-model:value="queryForm.daterange" :locale="locale" value-format="YYYY-MM-DD"
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.state" :options="qstates" style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-input v-model:value="queryForm.credit_number" placeholder="授信编号" style="width:100%;">
      </a-input>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="getData">查询</a-button>
    </a-col>
  </a-row>
  <div class="d-flex justify-space-between align-center mb-2">
    <a-space>
      <a-button type="link" @click="refresh">刷新数据</a-button>
    </a-space>
    <a-dropdown>
      <template #overlay>
        <a-menu>
          <a-menu-item @click="exportselected" :disabled="selectedRowKeys.length === 0">导出勾选</a-menu-item>
          <a-menu-item @click="exportall">导出所有页</a-menu-item>
          <a-menu-item @click="exporttask" class="text-error">查看导出任务</a-menu-item>
        </a-menu>
      </template>
      <a-button type="primary">
        导出数据
        <DownOutlined />
      </a-button>
    </a-dropdown>
  </div>
  <a-table bordered size="small" :columns="columns" :data-source="data" :loading="dataLoading"
    :scroll="{ x: width, y: 600 }"
    :pagination="{ current: page, pageSize: limit, total: count, showQuickJumper: true, showSizeChanger: true, showTotal: (total) => `共${total}条`, }"
    @change="(pagination) => { page = pagination.current; limit = pagination.pageSize; }" row-key="_id"
    :row-selection="{ selectedRowKeys, onChange: (keys) => selectedRowKeys = keys }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'amount'">
        {{ $filters.formatMoney(record.amount, 2, '') }}
      </template>
      <template v-if="column.dataIndex === 'state'">
        <a-tag v-if="record.state === 2" class="tag-warning">计息中</a-tag>
        <a-tag v-if="record.state === 3" class="tag-error">还款待审批</a-tag>
        <a-tag v-if="record.state === 4" class="tag-success">已还款</a-tag>
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a-button v-if="record.state === 3" type='link' class="text-error" @click="showAudit(record._id)">
            审核
          </a-button>
        </a-space>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="auditModal" title="审核" :maskClosable="!auditing" :closable="!auditing"
    @cancel="cancelAudit">
    <a-form ref="auditFormRef" name="auditForm" :model="auditForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }"
      autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="商户">
            {{ getorgname(auditForm.orgid) }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="授信编号">
            {{ auditForm.credit_number }}
          </a-form-item>
        </a-col>
        <template v-if="credit">
          <a-col :span="24">
            <a-form-item label="授信信息">
              <a-space>
                <span>额度(<span class="text-error">¥{{ credit.grant_quota }}</span>)</span>
                <span>已借款(<span class="text-success">¥{{ credit.loan_amount }}</span>)</span>
              </a-space>
            </a-form-item>
          </a-col>
        </template>
        <a-col :span="24">
          <a-form-item label="流水号">
            {{ auditForm.number }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="借款金额">
            <span class="text-error">{{ $filters.formatMoney(auditForm.amount, 2, '') }}</span>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="使用日期">
            {{ auditForm.apply_date }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="使用时长">
            {{ getduration(auditForm.apply_duration) }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="还款时间" name="repay_date" :rules="[{ required: true, message: '请选择还款时间' }]">
            <a-date-picker v-model:value="auditForm.repay_date" :locale="locale" :show-now="true"
              :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }" :show-today="true"
              value-format="YYYY-MM-DD HH:mm:ss" placeholder="还款时间" style="width:100%" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <template #footer>
      <div class="d-flex justify-end">
        <a-space>
          <a-button :disabled="auditing" @click="cancelAudit">取消</a-button>
          <a-button type="primary" :loading="auditing" @click="submitAudit">提交</a-button>
        </a-space>
      </div>
    </template>
  </a-modal>
</template>
<script setup>
import dayjs from "dayjs";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { DownOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, onActivated, getCurrentInstance, } from "vue";
import _ from "underscore";
const columns = [
  { title: '授信编号', dataIndex: 'credit_number', width: 100 },
  { title: '流水号', dataIndex: 'number', width: 120 },
  { title: '商户名称', dataIndex: 'org', width: 150 },
  { title: '借款金额(¥)', dataIndex: 'amount', width: 120, },
  { title: '状态', dataIndex: 'state', width: 100, },
  { title: '产生利息(¥)', dataIndex: 'interest', width: 100, },
  { title: '计息天数', dataIndex: 'days', width: 100, },
  { title: '申请还款时间', dataIndex: 'apply_repay_time', width: 120, },
  { title: '还款日期', dataIndex: 'repay_date', width: 120, },
  { title: '还款金额', dataIndex: 'repay_amount', width: 120, },
  { title: '操作', dataIndex: 'operation', width: 150, fixed: "right" }
];
const { proxy } = getCurrentInstance();
const auditFormRef = ref();
const queryForm = ref({
  daterange: ["", ""],
  orgid: "ALL",
  state: "ALL",
  credit_number: "",
});
const states = ref([
  { value: "2", label: "计息中" },
  { value: "3", label: "还款待审批" },
  { value: "4", label: "已还款" },
]);
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const orgs = ref([]);
const selectedRowKeys = ref([]);
const auditForm = ref({});
const auditModal = ref(false);
const auditing = ref(false);
const durations = ref([
  { value: 1, label: "1个月" },
  { value: 3, label: "3个月" },
  { value: 6, label: "6个月" },
  { value: 9, label: "9个月" },
  { value: 12, label: "1年" },
]);

const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const qstates = computed(() => {
  return [
    { value: 'ALL', label: '全部' },
    ...states.value,
  ]
});
const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  refresh();
});
const refresh = () => {
  getData();
}
const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/repay/list", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          apply_repay_time: n.apply_repay_time ? proxy.$dateFormat(n.apply_repay_time, 'YYYY-MM-DD HH:mm:ss') : '',
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const showAudit = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/repay/showaudit", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      auditForm.value = res.data.auditForm;
      auditModal.value = true;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const submitAudit = async () => {
  try {
    await auditFormRef.value.validateFields();
    auditing.value = true;
    proxy.$api.doAPI("/repay/audit", { dataForm: auditForm.value }).then((res) => {
      auditing.value = false;
      if (res.code === 0) {
        message.success("提交成功");
        auditModal.value = false;
        refresh();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      auditing.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
}
const cancelAudit = () => {
  auditFormRef.value.clearValidate();
  auditModal.value = false;
}
const exportselected = () => {
}
const exportall = () => {
}
const exporttask = () => {

}
const getorgname = (orgid) => {
  return _.findWhere(orgs.value, { _id: orgid })?.name;
}
const getduration = (value) => {
  return _.findWhere(durations.value, { value })?.label;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>